
import { Col, Container, Nav, Row } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import React, { useState } from 'react';
import './../assest/style/projects.css'

import market from './../assest/images/Services/market.png'
import ph from './../assest/images/Services/ph.png'
import one from './../assest/images/projectss/Before and After/1-1x1-1580855480.jpg'
import two from './../assest/images/projectss/Before and After/1.jpg'
import three from './../assest/images/projectss/Before and After/2.jpg'
import four from './../assest/images/projectss/Before and After/Subject Sample Image - PiXimperfect.jpg'
import five from './../assest/images/projectss/media/1.jpg'
import six from './../assest/images/projectss/media/1ب1.jpg'
import seven from './../assest/images/projectss/media/2-1.jpg'
import eight from './../assest/images/projectss/media/2.jpg'
import nine from './../assest/images/projectss/media/3.png'
import ten from './../assest/images/projectss/media/4.jpg'
import eleven from './../assest/images/projectss/media/5.jpg'
import tweleve from './../assest/images/projectss/media/back to school.jpg'
import thirten from './../assest/images/projectss/media/back to shcool.jpg'
import fourten from './../assest/images/projectss/media/BLACK FRIDAY.jpg'
import fiften from './../assest/images/projectss/media/christmas sale.jpg'
import sixten from './../assest/images/projectss/media/chritmas offers.jpg'
import seventen from './../assest/images/projectss/media/Colgate.jpg'
import eighten from './../assest/images/projectss/media/delicous.jpg.jpg'
import ninten from './../assest/images/projectss/media/effects.jpg'
import twenty from './../assest/images/projectss/media/emotional marketing.jpg'
import twentyone from './../assest/images/projectss/media/empathic research.jpg'
import twentytwo from './../assest/images/projectss/media/EPIC.jpg'
import twentythree from './../assest/images/projectss/media/fitness gym.jpg'
import twentyfour from './../assest/images/projectss/media/gym.jpg'
import twentyfive from './../assest/images/projectss/media/Hot burger.jpg'
import twentysix from './../assest/images/projectss/media/ما حدا بيقدر يقاوم الطعم.jpg'
import twentyeight from './../assest/images/projectss/media/قل للمليحة.jpg'
import twentynine from './../assest/images/projectss/media/شوكولا شباب المستقبل.jpg'
import thirty from './../assest/images/projectss/media/university.jpg'
import thirtyone from './../assest/images/projectss/media/super delicous.jpg'
import thirtytwo from './../assest/images/projectss/media/rali.jpg'
import thirtyeight from './../assest/images/projectss/media/IMG-20230623-WA0002.jpg'
import thirtythree from './../assest/images/projectss/media/IMG_6645.jpg'
import thirtyfour from './../assest/images/projectss/media/mbc 2.jpg'
import thirtyfive from './../assest/images/projectss/media/mbc iraq.jpg'
import thirtysix from './../assest/images/projectss/media/NINE IN ONE.jpg'
import thirtyseven from './../assest/images/projectss/media/perfume.jpg'
import un from './../assest/images/projectss/website/IMG-20230827-WA0011.jpg'
import deux from './../assest/images/projectss/website/perfume.jpg'
import trois from './../assest/images/projectss/website/website 4.jpg'
import quatre from './../assest/images/projectss/website/website 6.jpg'
import cinq from './../assest/images/projectss/website/website Black friday.jpg'
import sis from './../assest/images/projectss/website/website Black friday2.jpg'
import sept from './../assest/images/projectss/website/website Black friday3.jpg'
import huit from './../assest/images/projectss/website/website Black friday4.jpg'
import nuef from './../assest/images/projectss/website/website MBC IRAQ.jpg'

import B from './../assest/images/projectss/multi photos/9 IN ONE.jpg'
import C from './../assest/images/projectss/multi photos/coming soon.jpg'

import E from './../assest/images/projectss/multi photos/room renting 2.png'
import F from './../assest/images/projectss/multi photos/room renting.png'
import tune from './../assest/images/projectss/logo/New folder (2)/Deep Tune/Logo.jpg'

import messi from './../assest/images/projectss/multi photos/messi.jpg'
import girl from './../assest/images/projectss/multi photos/girl.jpg'
import m1 from './../assest/images/projectss/media/m1.jpg'
import m2 from './../assest/images/projectss/media/m2.jpg'
import m3 from './../assest/images/projectss/media/m3.jpg'
import m4 from './../assest/images/projectss/media/m4.jpg'
import m5 from './../assest/images/projectss/media/m5.jpg'
import m6 from './../assest/images/projectss/media/m6.jpg'
import m7 from './../assest/images/projectss/media/m7.jpg'
import m8 from './../assest/images/projectss/media/m8.jpg'


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';


// import required modules

// Import Swiper styles




import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';





// import required modules

import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane
} from 'mdb-react-ui-kit';
import Slider from 'react-slick';
import { Swiperr } from './Swiperr';
import { Magazine } from './Magazine';
import { Brochours } from './Brochours';
import { Certification } from './Certification';
import { Ai } from './Ai';
import { Content } from './Content';
import { Marketing } from './Marketing';
import { Videos } from './Videos';




export const Projects = () => {
    
  const [basicActive, setBasicActive] = useState('tab1');

  const handleBasicClick = (value: string) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };
  

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              initialSlide: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      };

      var sett = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              initialSlide: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      };


     
      const Sdata = [
        {
          id: 1,
          title: "Before And After Girl",
        
    cover:one
        },
        {
          id: 2,
          title: "Before And After Girl",
       
          cover:two
        },
        {
          id: 3,
          title: "Before And After Dog",
         
          cover:three
        },
        {
          id: 4,
          title: "Before And After Girl",
         
          cover:four
        },
      ]


      
      const tdata = [
    
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m1
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:twentyfive
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:nine
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:eighten
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:twentytwo
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:twentythree
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:twentyfour
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m4
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m5
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m6
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m7
        },
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:m8
        },
     
        {
          id: 2,
          title: "Media photos with special design",
       
          cover:five
        },
        {
          id: 3,
          title: "Media photos with special design",
         
          cover:six
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:seven
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:eight
        },
 
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:ten
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:eleven
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:tweleve
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:thirten
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:fourten
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:fiften
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:sixten
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:seventen
        },

        {
          id: 4,
          title: "Media photos with special design",
         
          cover:ninten
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twenty
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentyone
        },

        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentythree
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentyfour
        },

        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentysix
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentyeight
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:twentynine
        },

        {
          id: 4,
          title: "Media photos with special design",
         
          cover:m2
        },
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:m3
        },
       
        {
          id: 4,
          title: "Media photos with special design",
         
          cover:m8
        },
      ]

      
      const hdata = [
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:un
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:deux
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:trois
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:quatre
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:cinq
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:sis
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:sept
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:huit
        },
        {
    
          title: "My Designs for ZEN Diamond Website",
        
    cover:nuef
        }
      ]

      const fdata = [
 
        {
    
          title: " Multi Photo with special Design",
        
    cover:E
        },
        {
    
          title: " Multi Photo with special Design",
        
    cover:C
        },
   
        {
    
          title: " Multi Photo with special Design",
        
    cover:F
        },
        {
    
          title: " Multi Photo with special Design",
        
    cover:B
        },

        {
    
          title: " Multi Photo with special Design",
        
    cover:messi
        },
        {
    
          title: " Multi Photo with special Design",
        
    cover:girl
        },
      ]

      const Ddata = [
        {
        
          title: "Before And After Girl",
        
    cover:one
        }
      ]
      // const Ddata=[
      //   {
      //     cover:tune,
      //     title:"Deep Tune"
      //   },
      //   {
      //     cover:velbit,
      //     title:"Velbite"
      //   },
      //   {
      //   cover:VocalAtoms,
      //   title:"Vocal Atoms"
      // },
      // cover:alnashmy,
      // title:"Alnashmy Company"

      // ]
  return (
    <div className='projects'>
<h1> My Projects</h1>

<Container>









    
      <MDBTabs className='mb-3'>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
        images
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
         logo
          </MDBTabsLink>
        </MDBTabsItem>

        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
        magazine
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
          pruchors
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
        content writting
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab6')} active={basicActive === 'tab6'}>
          AI
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab7')} active={basicActive === 'tab7'}>
          Certificates
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab8')} active={basicActive === 'tab8'}>
   Marketing
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab9')} active={basicActive === 'tab9'}>
 Videos
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>
        <MDBTabsPane open={basicActive === 'tab1'}>


        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column colom">
            <Nav.Item>
              <Nav.Link eventKey="second" className='bb'>Media</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="first" className='bb'>Before And After</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="third" className='bb'>Website</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="fourth" className='bb'>multi photo</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={9}>
          <Tab.Content>
            <Tab.Pane eventKey="first">
             
            <div className='row'>

    <div className='col-lg-12 col-md-12 col-sm-12 na'>
       <Slider {...settings}>
    {Sdata.map((value,index)=>{
        return(
            <div className='in d-flex' key={index}>
       
<div className='text '>
<h1> {value.title}</h1>

<button>Contact us</button>

</div>

<div className='imag'>
    <img src={value.cover}/>
</div>

</div>

        )
    })}
</Slider>
</div>
    </div>
  
            </Tab.Pane>
            <Tab.Pane eventKey="second">

            <div className='row'>

<div className='col-lg-12 col-md-8 col-sm-12 na'>
   <Slider {...settings}>
{tdata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        
<div className='text '>
<h1> {value.title}</h1>

<button>Contact us</button>
</div>
<div className='imag imagee sss'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
</div>
</div>
            </Tab.Pane>
            <Tab.Pane eventKey="third">
            <div className='row'>

<div className='col-lg-12 col-md-8 col-sm-12 na'>
   <Slider {...settings}>
{hdata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        
<div className='text '>
<h1> {value.title}</h1>

<button>Contact us</button>
</div>
<div className='imag thth'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
</div>
</div>
            </Tab.Pane>
            <Tab.Pane eventKey="fourth">
            <div className='row'>

<div className='col-lg-12 col-md-8 col-sm-12 na'>
   <Slider {...settings}>
{fdata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        
<div className='text '>
<h1> {value.title}</h1>

<button>Contact us</button>
</div>
<div className='imag imagee'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
</div>
</div>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
        </MDBTabsPane>
        <MDBTabsPane open={basicActive === 'tab2'}>

        <div className='all'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
           <Swiperr/>
    </div>
    </div>
</div>
        </MDBTabsPane>
        <MDBTabsPane open={basicActive === 'tab3'}>
          <Magazine/>
          </MDBTabsPane>
        <MDBTabsPane open={basicActive === 'tab4'}>
<Brochours/>
        </MDBTabsPane>
        <MDBTabsPane open={basicActive === 'tab5'}>
          <Content/>
        </MDBTabsPane>
        <MDBTabsPane open={basicActive === 'tab6'}>
          <Ai/></MDBTabsPane>     
         <MDBTabsPane open={basicActive === 'tab7'}>

          <Certification/>
         </MDBTabsPane>.
         <MDBTabsPane open={basicActive === 'tab8'}>
<Marketing/>

</MDBTabsPane>
<MDBTabsPane open={basicActive === 'tab9'}>
<Videos/>

</MDBTabsPane>
      </MDBTabsContent>



    </Container>


    </div>
  )
}
